import { InferGetStaticPropsType } from 'next';

import {
  Layout2,
  SeoData,
  PostList,
  CaseStudyCard,
  Select,
  Pagination,
  SideContents,
} from '@components';
import { getStaticProps } from '@/src/pages/knowledge/[casestudyType]';
import { BreadcrumbsData } from '@components';
import { minIndexablePostCount } from '@constants';

type Props = InferGetStaticPropsType<typeof getStaticProps> & {
  breadcrumbs?: BreadcrumbsData;
  hnaviCategory?: string | null;
  onHnaviCategorySelectChange?: React.FormEventHandler<HTMLSelectElement>;
  pageCount: number;
  pageTitle?: string | null;
  paginationBasePath?: string;
  seoData?: SeoData | null;
  showFirstPostAsHeroPost?: boolean;
};

export const CaseStudyListPage: React.FC<Partial<Props>> = ({
  breadcrumbs,
  categories,
  hnaviCategory,
  hnaviOptions,
  onHnaviCategorySelectChange,
  pageCount,
  pageNo,
  pageTitle,
  paginationBasePath,
  posts,
  relatedTokushuPosts,
  seoData,
  hnaviContentCategories,
}) => (
  <Layout2
    useHnaviHeader
    hnaviContentCategories={hnaviContentCategories}
    categories={categories}
    seoData={{
      ...seoData,
      metaRobotsNoindex:
        (posts?.length || 0) <= minIndexablePostCount
          ? 'noindex'
          : seoData?.metaRobotsNoindex,
      titlePrefix: (pageNo || 0) > 1 ? `${pageNo}ページ目 ` : undefined,
    }}
    pageTitle={pageTitle || 'ご利用事例'}
    breadcrumbs={breadcrumbs || seoData?.breadcrumbs}
    sideBar={
      <SideContents
        postGroups={[{ groupName: '関連特集記事', posts: relatedTokushuPosts }]} // TODO
        fixedBanner={hnaviOptions?.banners?.buyerFixed}
      />
    }
  >
    <div className='my-8 text-center'>
      <Select
        options={Object.entries(hnaviContentCategories || {})}
        blankOption='カテゴリから事例を探す'
        defaultValue={hnaviCategory || ''}
        onChange={onHnaviCategorySelectChange}
      />
    </div>
    {posts?.length ? (
      <PostList
        posts={posts}
        render={(post) => (
          <CaseStudyCard
            title={post.title}
            slug={post.slug}
            coverImage={post.featuredImage?.node}
            /* TODO */
            caseStudyData={{
              buyerName: post.hnavi?.buyerName,
              developerName: post.hnavi?.developerName,
              industry: post.hnavi?.buyerIndustry,
              title: post.hnavi?.productionName,
              developerLogoImage: post.hnavi?.hnaviSubImage?.mediaItemUrl,
            }}
          />
        )}
      />
    ) : null}
    {pageCount && (
      <Pagination pageCount={pageCount} basePath={paginationBasePath} />
    )}
  </Layout2>
);
